import {
  profile,
  researchGroup,
  researchPlatform
} from '@stereoagency/sanity-schema';

const researchGroupQuery = researchGroup.schema.builder
  .filter('references(^._id)')
  .pick(['_type', '_id', 'title', 'slug'])
  .use();

const researchPlatformQuery = researchPlatform.schema.builder
  .filter('references(^._id)')
  .pick(['_type', '_id', 'title', 'slug'])
  .use();

export const profilesQuery = profile.schema.builder
  .pick([
    '_id',
    'name',
    'firstName',
    'image',
    'subtitle',
    'introduction',
    'pubmedQuery',
    'email',
    'phone',
    'address',
    'hideFromListing'
  ])
  .subquery({
    isGroupLeader: [
      `count(*[_type == "${researchGroup.schema.document.name}" && researchGroupLeader._ref == ^._id]) > 0`,
      false
    ],
    researchGroups: researchGroupQuery,
    researchPlatforms: researchPlatformQuery
  })
  .use();
